export default {"src":"/_next/static/media/counting_up_logo.4776ae34.svg","height":78,"width":295,"blurWidth":0,"blurHeight":0};